exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number-icon {\n    background-color:rgba(224, 28, 47, 0.7);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 30px !important;\n    width: 30px !important;\n}\n", ""]);

// exports
